/* eslint-disable max-depth */
/* eslint-disable no-continue */
import React, { useContext } from 'react';
import { jsonLdScriptProps } from 'react-schemaorg';
import { GovernmentOrganization } from 'schema-dts';
import { PageType } from 'types/publishedAssets';
import { PageContext } from 'src/context/PageContext';
import { determineHomepage, determineLogoRedirectUrl, determineThemeName } from 'utils/determineUrls';
import Head from 'next/head';
import { useTranslatableField } from 'utils/useTranslatableField';
import { determineLogoImage } from '../PageHelpers';

interface PageProps {
  page: PageType;
}
export function GovermentOrganizationStructuredData(props: PageProps): JSX.Element | null {
  const { page } = props;
  const { slug, theme, urlParams, canonicalHostname } = useContext(PageContext);
  const { translateField } = useTranslatableField(urlParams?.locale);

  let email: string | undefined;
  let telephone: string | undefined;
  let sameAs: string[] = [];
  const getContactInformation = () => {
    const alternateHomePageurl = determineLogoRedirectUrl(theme);
    if (alternateHomePageurl) {
      sameAs.push(alternateHomePageurl);
    }
    for (let sectionIt = 0; sectionIt < page?.sections?.length; sectionIt++) {
      const section = page?.sections?.[sectionIt];
      for (let entityIt = 0; entityIt < section?.section_entities?.length; entityIt++) {
        const entity = section?.section_entities?.[entityIt];
        if (!entity) continue;
        if (entity.content_type !== 'contact_us') continue;
        telephone = entity?.metadata?.phone_number;
        email = entity?.metadata?.email;
        for (let componentIt = 0; componentIt < entity?.components?.length; componentIt++) {
          const component = entity?.components?.[componentIt];
          if (!component) continue;
          if (!component?.metadata?.contact_value) continue;
          sameAs.push(component.metadata.contact_value);
        }
        sameAs = [...new Set(sameAs)];
        return;
      }
    }
  };
  getContactInformation();

  return (
    <Head>
      <script
        key="structured-data"
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...jsonLdScriptProps<GovernmentOrganization>({
          '@context': 'https://schema.org',
          '@type': 'GovernmentOrganization',
          name: determineThemeName(theme, translateField),
          url: determineHomepage(slug?.[0] || '', urlParams?.locale, canonicalHostname) || undefined,
          sameAs,
          logo: determineLogoImage(theme!, translateField),
          email,
          telephone,
        })}
      />
    </Head>
  );
}
